import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';

import useShopRecommendedItems from './hooks/useShopRecommendedItems';
import RecommendationItem from './RecommendationItem';

interface Props {
    shopId: string;
    itemId: string;
}

function Recommendation({ shopId, itemId }:Props) {
    const { title, items } = useShopRecommendedItems(shopId, itemId);
    return (
        <Container fullWidth as='section'>
            {title && (
                <TitleWrapper>
                    <Text size='xl' fontWeight='bold'>{title}</Text>
                </TitleWrapper>
            )}
            <Contents as='article' spacing={12}>
                {items?.map((item) => (
                    <RecommendationItem item={item}
                        shopId={shopId}
                        key={item.shopItemId} />
                ))}
            </Contents>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 16px 0 14px;
`;

const TitleWrapper = styled.div`
    padding: 0 20px;
`;

const Contents = styled(Row)`
    padding: 20px;
    scroll-snap-type: x mandatory;
    scroll-padding: 0 20px;
    max-width: 100%;
    overflow-x: auto;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export default Recommendation;
